import React, { createContext, useContext, type ReactNode } from "react";
import { ProvetTranslations } from "../types";

interface TranslationContextType {
  translations?: ProvetTranslations | undefined;
}

interface TranslationContextProviderProps {
  children: ReactNode;
  translations: ProvetTranslations | undefined;
}

export const TranslationContext = createContext<TranslationContextType>({});

export const TranslationContextProvider = ({
  children,
  translations
}: TranslationContextProviderProps) => (
  <TranslationContext.Provider value={{ translations }}>
    {children}
  </TranslationContext.Provider>
);

export const useTranslationContext = () => useContext(TranslationContext);
